import React from 'react';
import { InputNumber } from 'antd';
import './NumericInputStyle.css';

const NumericInput = props => {
    const { def, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    const checkNumeric = (value) => {
        if (isNaN(value) && value !== '') return;
        onChange(def.dataKey, value);
    }

    return <InputNumber
        id={def.dataKey}
        data-input={'numberinput_de'}
        className={'numberinput_de'}
        status={err}
        readOnly={state.readonly}
        disabled={state.readonly}
        value={data}
        onChange={checkNumeric}
        placeholder={def.placeholder}
        type='number'
        controls={false}
    />
}

export default NumericInput;
